// extracted by mini-css-extract-plugin
module.exports = {"cardSimple-container":"CardSimpleUI_cardSimple-container__obJTW","cardSimple-paragraph":"CardSimpleUI_cardSimple-paragraph__fm_wB"};